import { AdminAppState } from '../../state';
import { CreateEventInput } from '../../mutations';
import { getEventCategoryIds } from './get-event-category-ids';
import { getEventDescription } from './get-event-description';
import { getEventName } from './get-event-name';
import { getEventOccurrences } from './get-event-occurrences';
import { getEventPageId } from './get-event-page-id';
import { getEventPlaceId } from './get-event-place-id';
import { getEventPosterImages } from './get-event-poster-images';
import { getEventTagsArray } from './get-event-tags-array';
import { getImage } from '../image';
import { identity } from 'lodash';

export const getCreateEventInput = (eventKey: string) => (
  state: AdminAppState,
): CreateEventInput => {
  const posterImages = getEventPosterImages(eventKey)(state);

  const images = posterImages
    .map(({ imageKey, type }) => {
      const image = getImage(imageKey)(state);
      if (image.id) {
        return { imageId: image.id, type };
      } else {
        return null;
      }
    })
    .filter(identity) as CreateEventInput['images'];

  return {
    categoryIds: getEventCategoryIds(eventKey)(state),
    description: getEventDescription(eventKey)(state),
    images,
    name: getEventName(eventKey)(state),
    occurrences: getEventOccurrences(eventKey)(state)
      .filter(occ => !!occ.startsAt)
      .map(({ startsAt, duration }) => ({
        startsAt,
        duration,
      })) as CreateEventInput['occurrences'],
    pageId: getEventPageId(eventKey)(state),
    placeId: getEventPlaceId(eventKey)(state),
    tags: getEventTagsArray(eventKey)(state),
  };
};
